export default "__VITE_ASSET__B8k6tpp1__"